import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setWorkoutSummaryParameters, resetNavigationState } from 'redux/slices/navigation'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { GetDateTimeDisplay } from 'functions/textUtils'
import StrengthIcon from 'media/icons/strength.png'
import MobilityIcon from 'media/icons/mobility.png'
import moment from 'moment'

export default function WorkoutListItem({ workout }) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const workoutName = workout.name || ''
    const completedDate = workout.completedDate || workout.timestamp
    const hasValidCompletedDate = moment.utc(completedDate).local().isValid()

    const GetWorkoutIcon = (name) => {
        if (name.toLowerCase().includes('strength')) return StrengthIcon
        if (name.toLowerCase().includes('mobility')) return MobilityIcon
        return StrengthIcon
    }

    const OnViewWorkoutButton = () => {

        dispatch(resetNavigationState())

        const payload = {
            userId: workout.traineeId || workout.userId,
            workoutId: workout.completedWorkoutId
        }

        dispatch(setWorkoutSummaryParameters(payload))

        navigate('/workout/summary')

    }

    return (
        <div 
            className="w-full flex items-center px-6 py-4 gap-x-6 hover:bg-gray-50 cursor-pointer"
            onClick={() => OnViewWorkoutButton()}
        >
            <div className="h-12 w-12 bg-orange-400 rounded-full items-center">
                <img src={GetWorkoutIcon(workoutName)} alt="Workout Icon" className="h-6 m-3 invert" />
            </div>

            <div className="flex-grow">
                <p className="font-semibold">{workoutName}</p>
                <p className="text-sm">{workout.firstName} {workout.lastName}</p>
            </div>

            {hasValidCompletedDate && (
                <p className="w-64 text-left text-sm">{GetDateTimeDisplay(completedDate)}</p>
            )}

            {!hasValidCompletedDate && (
                <p className="w-64 text-left text-sm">Incomplete</p>
            )}
            
            <ChevronRightIcon className="text-gray-400 h-8" />
        </div>
    )
}